module.exports = __webpack_public_path__ + "static/media/Holistal uses telemedicine software for digital healthcare.0352e783.webp";